import React from 'react';
import { AuthProvider } from './context/AuthContext';
import { AppProvider } from './context/AppContext';
import { DataProvider } from './context/DataContext';
import { CartProvider } from './context/CartContext';
import { OrderProvider } from './context/OrderContext';
import { TableProvider } from './context/TableContext';
import AppRouter from './components/AppRouter';
import './index.css';

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <DataProvider>
          <TableProvider>
            <CartProvider>
              <OrderProvider>
                <div className="mobile-container">
                  <AppRouter />
                </div>
              </OrderProvider>
            </CartProvider>
          </TableProvider>
        </DataProvider>
      </AppProvider>
    </AuthProvider>
  );
}

export default App;
